export default function Connector() {
  return (
    <div>Connector</div>
  )
}
